module.exports = __webpack_public_path__ + "img/ios-device-icon.ae024773.svg";